import { fromEnumAsString } from '../../../serialization/enum-utils.js';
import { MapUtils } from '../../../utility/map-utils.js';
import { DataModel, DataModelBuilder, SerializationContext, SerializedData } from '../../dto/dto.js';
import { LegacyOrderHook, LegacyOrderHookId } from '../legacy-order-hook.js';
import { OrderSideEffectType } from './order-side-effect-type.js';
import { OrderSideEffect } from './order-side-effect.js';

export class RedirectAfterPaymentSideEffect extends OrderSideEffect {
  static readonly TYPE_ID: string = '6b168068a71b43eba0e11ab5d0d2570a';

  public readonly effectType: OrderSideEffectType = OrderSideEffectType.RedirectAfterPayment;

  private constructor(
    public readonly webRoute: string,
    public readonly isEvent: boolean,
  ) {
    super();
  }

  get $typeId(): string {
    return RedirectAfterPaymentSideEffect.TYPE_ID;
  }

  static fromEvent(webRoute: string): RedirectAfterPaymentSideEffect {
    return new RedirectAfterPaymentSideEffect(webRoute, true);
  }

  static create({ webRoute, isEvent }: { webRoute: string, isEvent: boolean }): RedirectAfterPaymentSideEffect {
    return new RedirectAfterPaymentSideEffect(webRoute, isEvent);
  }

  static fromMap(context: SerializationContext, map: SerializedData): RedirectAfterPaymentSideEffect {
    return new RedirectAfterPaymentSideEffect(
        MapUtils.getString(map, 'webRoute'),
        MapUtils.getBoolean(map, 'isEvent'),
    );
  }

  toMap(_context: SerializationContext): SerializedData {
    return {
      'effectType': fromEnumAsString(this.effectType),
      'webRoute': this.webRoute,
      'isEvent': this.isEvent,
    };
  }

  clone(): this {
    return new RedirectAfterPaymentSideEffect(
        this.webRoute,
        this.isEvent,
    ) as this;
  }

  isSame(other: RedirectAfterPaymentSideEffect): boolean {
    if(this === other) {
      return true;
    }

    return other.effectType === this.effectType &&
      other.webRoute === this.webRoute &&
      other.isEvent === this.isEvent;
  }

  toLegacyOrderHook(): LegacyOrderHook {
    return LegacyOrderHook.create(LegacyOrderHookId.RedirectAfterPayment, {
      webRoute: this.webRoute,
      isEvent: this.isEvent,
    });
  }

  static verifyType(order: DataModel): boolean {
    return order instanceof RedirectAfterPaymentSideEffect;
  }

  static assertType(order: DataModel): order is RedirectAfterPaymentSideEffect {
    return order instanceof RedirectAfterPaymentSideEffect;
  }
}

export class RedirectAfterPaymentSideEffectBuilder extends DataModelBuilder<RedirectAfterPaymentSideEffect> {
  build(context: SerializationContext, map: SerializedData): RedirectAfterPaymentSideEffect {
    return RedirectAfterPaymentSideEffect.fromMap(context, map);
  }
}
